<script>
	import { fade } from "svelte/transition";

	import Contact from "../../components/Contact.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import Select from "../../components/Select.svelte";
	import RadioGroup from "../../components/RadioGroup.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { yesNoOptions, referralTypes, relationshipTypes } from "../../config";
	import { getTealiumID } from "../../tealium";

	export let disabled = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;
	export let title = null;
	let required = true;

	if (!disabled) {
		pageNumber.update((p) => pageIndex);
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		$model.TealiumId = getTealiumID();
	}
	// if (typeof window !=="undefined" && window.analytics && window.analytics.user){
	//     $model.RegistrationSegmentId = window.analytics.user().anonymousId();
	// }

	let otherClaimant = null;
	if ($model.RegistrationType == "Individual (Myself)") {
		otherClaimant = "No";
	} else if ($model.RegistrationType == "Individual (Someone Else)") {
		otherClaimant = "Yes";
	}
	$: $model.RegistrationType = otherClaimant == "Yes" ? "Individual (Someone Else)" : "Individual (Myself)";
</script>

<PageSection>
	<h2>Your Contact Details</h2>

	<form novalidate autocomplete="off">
		<Contact
			bind:salutation={$model.Contact.Title}
			bind:firstName={$model.Contact.FirstName}
			bind:surname={$model.Contact.Surname}
			bind:dateOfBirth={$model.Contact.DateOfBirth}
			bind:emailAddress={$model.Contact.EmailAddresses[0].EmailAddress}
			bind:phoneNumber={$model.Contact.PhoneNumbers[0].PhoneNumber}
			bind:address={$model.Contact.Addresses[0]}
			idPrefix="cont"
			{required}
			{disabled}
		></Contact>

		<div class="form-row">
			<div class="form-group col-md-12">
				<label class:isrequired={required}>Are you completing this form on someone else's behalf?</label>
				<RadioGroup
					name="ContactIsClaimant"
					bind:value={otherClaimant}
					optionList={yesNoOptions}
					{required}
					{disabled}
				></RadioGroup>
				<div class="radio-error"></div>
			</div>
		</div>

		{#if otherClaimant == "Yes"}
			<div class="form-row">
				<div class="form-group col-md-12">
					<label class:isrequired={required}>Was this person (also) on board the Ruby Princess?</label>
					<RadioGroup
						name="ClaimantRubyPrincessPassenger"
						bind:value={$model.ClaimantRubyPrincessPassenger}
						optionList={yesNoOptions}
						{required}
						{disabled}
					></RadioGroup>
					<div class="radio-error"></div>
				</div>
			</div>

			<div class="form-row">
				<div class="form-group col-md-12">
					<label class:isrequired={required}
						>Do you have authority to complete this form on their behalf?</label
					>
					<RadioGroup
						name="ClaimantAuthority"
						bind:value={$model.ClaimantAuthority}
						optionList={yesNoOptions}
						{required}
						{disabled}
					></RadioGroup>
					<div class="radio-error"></div>
				</div>
			</div>

			<div class="form-row">
				<div class="form-group col-md-12">
					<label for="ClaimantRelationship" class:isrequired={required}
						>What is their relationship to you?</label
					>
					<Select
						{required}
						{disabled}
						id="ClaimantRelationship"
						bind:value={$model.ClaimantRelationship}
						optionList={relationshipTypes}
						textProperty="name"
						valueProperty="name"
					></Select>
				</div>
			</div>

			<div class="form-row">
				<div class="form-group col-md-12">
					<label class:isrequired={required}>Is this person the main contact for Shine?</label>
					<RadioGroup
						name="ClaimantMainContact"
						bind:value={$model.ClaimantMainContact}
						optionList={yesNoOptions}
						{required}
						{disabled}
					></RadioGroup>
					<div class="radio-error"></div>
				</div>
			</div>

			<Contact
				bind:salutation={$model.Claimant.Title}
				bind:firstName={$model.Claimant.FirstName}
				bind:surname={$model.Claimant.Surname}
				bind:emailAddress={$model.Claimant.EmailAddresses[0].EmailAddress}
				bind:phoneNumber={$model.Claimant.PhoneNumbers[0].PhoneNumber}
				bind:address={$model.Claimant.Addresses[0]}
				idPrefix="claim"
				{required}
				{disabled}
			></Contact>
		{/if}

		<div class="form-row">
			<div class="form-group col-md-12">
				<label for="whereDidYouHear" class:isrequired={required}
					>Where did you hear about this class action?</label
				>
				<Select
					{required}
					{disabled}
					id="whereDidYouHear"
					bind:value={$model.WhereDidYouHear}
					optionList={referralTypes}
					textProperty="name"
					valueProperty="name"
				></Select>
			</div>
		</div>

		<div class="form-row">
			<div class="form-group col-md-12">
				<Checkbox
					{required}
					{disabled}
					bind:checked={$model.PrivacyPolicyConfirmed}
					label="I agree to the Shine Lawyers <a target='_blank' href='https://www.shine.com.au/privacy-policy'>privacy policy</a>"
				></Checkbox>
			</div>
		</div>

		{#if !disabled}
			<div class="form-row">
				<div class="col-md-12 last">
					<NavigationButtons {persistUrl} {previousPage} {nextPage} tealiumTag={true} pageName={title}
					></NavigationButtons>
				</div>
			</div>
		{/if}
	</form>
</PageSection>
